export class Tenant{
  id?: string;
  name?: string;
}
